<template>
    <div>

        <div v-if="!fixo && adicoes && adicoes.length" class="mb-2">
            <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="selecionarAdicao(adicao)" v-for="(adicao, iax) in adicoes" :key="iax">
                {{ adicao.st_titulo }}
            </button>
        </div>

        <div class="row d-flex justify-content-center mb-2">

            <div class="col col-12">

                <az-input 
                    placeholder="Selecione o Profissional..."
                    icon="fas fa-briefcase-medical fa-fw"
                    type="autocomplete" 
                    service="medicos.index"
                    optionsDisplay="st_nome_exibicao"
                    required
                    :edicao="!fixo"
                    :validate="validate"
                    v-model="dados.medico"
                    ref="info_medico_outro" />

            </div>

        </div>

        <div class="row d-flex justify-content-center mb-2">

            <div class="col col-12">

                <az-input 
                    type="button-group"
                    :optionsList="[
                        { id: 'P', search: 'Paciente' },
                        { id: 'N', search: 'Não Paciente' },
                    ]"
                    optionsData="id"
                    v-model="dados.tipo" />

            </div>

        </div>

        <!-- Paciente -->

        <div class="row d-flex justify-content-center mb-2" v-if="dados.tipo == 'P'">

            <div class="col col-12">

                <az-input 
                    placeholder="Informe o nome ou CPF do paciente..."
                    icon="fas fa-user fa-fw"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    required
                    :validate="validate"
                    v-model="dados.paciente" 
                    :optimized_ac="true" />

            </div>

        </div>

        <!-- Não Paciente -->

        <div class="row d-flex justify-content-center mb-2" v-if="dados.tipo == 'N'">

            <div class="col col-12">

                <az-input 
                    placeholder="Informe o Nome..."
                    icon="fas fa-user fa-fw"
                    required
                    :validate="validate"
                    v-model="dados.st_nome"
                    ref="info_nome_outro" />

            </div>

        </div>

        <!-- Observação -->

        <div class="row d-flex justify-content-center mb-2">

            <div class="col col-12">

                <az-input 
                    placeholder="Observação..."
                    type="textarea"
                    icon="fa fa-comment fa-fw"
                    v-model="dados.st_observacoes"
                    ref="info_obs_outro" />

            </div>

        </div>

        <div class="d-flex flex-column">
            <az-submit @click="salvar()">Incluir</az-submit>
        </div>
        
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default { 
    data() { 
        return { 
            dados: { 
                medico: "",
                paciente: "",  
                st_nome: "", 
                st_observacoes: "", 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                id_recepcao: this.$util.getCookie('id_recepcao'), 
                tipo: 'P'
            },
            validate: false, 
            fixo: false, 
        };
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    computed: { 
        adicoes: function () { 
            let recep = this.$util.recepcao();

            return recep ? recep.adicoes.filter(item => item.st_tipo && item.st_tipo != 'A')
                .filter(item => !item.fl_preferencial) : [];
        }
    },

    methods: { 
        salvar () { 
            if ( this.dados.paciente ) { 
                this.dados.st_nome = this.dados.paciente.st_nome;
            }

            this.$util.atualizar(this, { 
                service: 'atendimento_outros',
                dados: { 
                    ...this.dados, 
                    id_medico: this.dados.medico ? this.dados.medico.id_pessoa : null, 
                    id_paciente: this.dados.paciente ? this.dados.paciente.id_pessoa : null, 
                },
                modal: 'novoAtendimento2Modal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        selecionarAdicao (adicao = null, fixo = false) { 
            if ( !adicao ) { 
                this.dados.medico = "";
                this.dados.st_observacoes = "";
                return;
            }

            this.fixo = fixo;

            this.$util.load(this, { 
                service: 'medicos',
                func: 'show',
                parms: { 
                    id: adicao.id_medico,
                },
                loadTo: res => { 
                    this.dados.medico = res;
                    this.dados.st_observacoes = adicao.st_titulo;
                }
            });
        },
    }
}
</script>